export default "__VITE_ASSET__CthxUwOl__"